<template>
  <v-card class="segmentation-size-component">
    <v-container>
      <v-row>
        <p class="segmentation-size-title">Tamanho do segmento</p>
      </v-row>
      <v-row>
        <span class="segmentation-size">{{ size }}</span>
      </v-row>
      <v-row>
        <export-client-button :segment="segment" :disabled="!segment || size <= 0" small />
      </v-row>
    </v-container>
  </v-card>
</template>

<script>
import ExportClientButton from '@/modules/clientes/segmentation/views/components/ExportClientButton.vue'

export default {
  components: {
    ExportClientButton,
  },
  props: {
    size: {
      type: Number,
      required: true,
    },
    segment: {
      type: Object,
      required: true,
    },
  },
}
</script>
]
<style lang="scss">
.segmentation-size-component {
  margin-left: 15px;
  padding: 0 22px;

  .segmentation-size-title {
    font-size: 12px;
    color: $cinza-l10;
    margin-bottom: 2px;
  }

  .segmentation-size {
    font-size: 35px;
    color: $cinza-d20;
  }
}
</style>
